import React from "react";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";
import ErrorPage from "pages/ErrorPage/ErrorPage";
import AdminCreateOrderPage from "pages/RecruitersView/CreateOrderPage/AdminCreateOrderPage";
import RecruiterCreateOrderPage from "pages/RecruitersView/CreateOrderPage/RecruiterCreateOrderPage";

export default function CreateOrderSwitch() {
  const appContext = useAppContext();
  const { account } = appContext;
  const { accountType } = account;

  if (accountType.type === ACCOUNT_TYPES.ADMIN.type) {
    return <AdminCreateOrderPage />;
  } else if (accountType.type === ACCOUNT_TYPES.RECRUITER.type) {
    return <RecruiterCreateOrderPage />;
  } else {
    return <ErrorPage />;
  }
}
